import { useEffect, useState } from "react"
import { useQuery } from "urql"

import type { PriceChangeFilterOptions, PriceChangeType, Query } from "@/graphql/codegen/graphql"
import { GetPriceChangeFilterOptionsDocument } from "@/graphql/codegen/graphql"

interface UseGetPriceChangeFilterOptionsReturn {
  filterOptions: PriceChangeFilterOptions | null
  fetching: boolean
}

export const useGetPriceChangeFilterOptions = ({
  changeType,
  supplierId,
  customerIds,
  productCategoryId,
  productClassId,
  specificProductIds,
}: {
  changeType?: PriceChangeType
  supplierId?: string
  customerIds?: string[]
  productCategoryId?: string
  productClassId?: string
  specificProductIds?: number[]
}): UseGetPriceChangeFilterOptionsReturn => {
  const [filterOptions, setFilterOptions] = useState<PriceChangeFilterOptions | null>(null)

  const [{ data, fetching }] = useQuery<Pick<Query, "priceChange">>({
    query: GetPriceChangeFilterOptionsDocument,
    variables: {
      input: {
        ...(changeType && changeType?.length && { changeType }),
        ...(supplierId && supplierId?.length && { supplierId }),
        ...(customerIds && customerIds?.length && { customerIds }),
        ...(productCategoryId && productCategoryId?.length && { productCategoryId }),
        ...(productClassId && productClassId?.length && { productClassId }),
        ...(specificProductIds && specificProductIds?.length && { specificProductIds }),
      },
    },
    pause: !changeType,
  })

  useEffect(() => {
    if (data?.priceChange?.getPriceChangeFilterOptions?.__typename === "GetPriceChangeFilterOptionsSuccess") {
      setFilterOptions(data.priceChange.getPriceChangeFilterOptions.filterOptions)
    }
  }, [data])

  return {
    filterOptions,
    fetching,
  }
}
